<template>
  <main>
    <Trail
      :list="[
        {
          path: '/proyectos/investigacion',
          name: 'Projects',
          tag: 'Proyectos de Investigación'
        },
        {
          name: 'INCAGRO',
          tag: 'INCAGRO'
        }
      ]"
    />
    <Container class="container--main">
      <Title tag="h1" align="center">
        INCAGRO: Subproyecto de Investigación Estratégica
      </Title>
      <section>
        <Title tag="h4" align="center" theme="secondary">
          Pronóstico Estacional de Lluvias y Temperaturas en la Cuenca del Río
          Mantaro para su Aplicación en la Agricultura
        </Title>
        <Figure>
          <Image
            :srcsets="['/images/proyectos/incagro/incagro.jpg']"
            title="Agricultores en el Valle del Mantaro"
          />
        </Figure>
      </section>
      <Row>
        <ColumnUi md="9">
          <Navtab id="introduccion">
            <Title tag="h2">Introducción</Title>
            <p>
              Durante la ejecución del
              <router-link to="/proyectos/proclim"
                >proyecto PROCLIM</router-link
              >
              se realizó un análisis de los principales peligros de origen
              hidrometeorológico que afectaba a la población de la cuenca del
              río Mantaro. Se encontró que las sequías, heladas y los
              deslizamientos (huaycos) afectaban las actividades de la
              población, entre ellas a la agricultura. Es por ello que los
              agricultores deseaban tener información climática a mediano plazo
              (con meses de anticipación) para planificar sus actividades, ya
              que los escenarios climáticos a 50 años, según su apreciación,
              estaban bastante lejos y escapaban de sus posibilidades de
              planificar. Es así como surge la necesidad de contar con
              pronósticos del clima a nivel estacional. El año 2006, el IGP
              postuló al concurso del Fondo de Desarrollo de Servicios
              Estratégicos (FDSE), del programa de
              <a href="http://www.incagro.gob.pe"
                >Innovación y Competitividad para el Agro peruano (INCAGRO)</a
              >, con el proyecto "Pronóstico de lluvias y temperaturas en la
              cuenca del río Mantaro para su aplicación en la agricultura",
              obteniendo financiamiento para desarrollar dicho proyecto en el
              valle del Mantaro. Contrato N° 2006-0013-AG-INCAGRO-FDSE.
            </p>
          </Navtab>
          <Navtab id="objetivos">
            <Title tag="h2">
              Objetivos general y específico del proyecto
            </Title>
            <p>
              Generar y usar pronósticos climáticos para la agricultura en la
              cuenca del río Mantaro.Que se desarrolló mediante los siguientes
              objetivos específicos:
            </p>
            <List tag="ol">
              <li>
                Mejorar el conocimiento de los mecanismos que controlan los
                procesos físicos de lluvias y temperaturas en la cuenca del río
                Mantaro y las causas de la variabilidad espacial y temporal de
                estas variables.
              </li>
              <li>
                Dar a conocer la importancia y el valor de la información
                climática sobre lluvias y temperaturas en la cuenca del río
                Mantaro para su uso por parte de los potenciales usuarios
              </li>
              <li>
                Desarrollar la capacidad de generar pronósticos climáticos en la
                cuenca del río Mantaro.
              </li>
            </List>
          </Navtab>
          <Navtab id="duracion">
            <Title tag="h2">
              Duración del proyecto
            </Title>
            <p>
              Enero de 2007-julio 2010
            </p>
          </Navtab>
          <Navtab id="estrategias">
            <Title tag="h2">
              Estrategias del proyecto
            </Title>
            <p>
              El proyecto se llevó a cabo mediante el desarrollo de cinco
              componentes y sus respectivas actividades:
            </p>
            <List tag="ol">
              <li>
                <b>
                  Sistematizar la información climática de la cuenca del río
                  Mantaro
                </b>
                <List tag="ol">
                  <li>Inventario de la base de datos del IGP</li>
                  <li>Actualizar la base de datos</li>
                  <li>Creación de una base de datos</li>
                </List>
              </li>
              <li>
                <b>
                  Conocer los procesos físicos atmosféricos que rigen las
                  lluvias y temperaturas en la cuenca del río Mantaro:
                </b>
                <List tag="ol">
                  <li>
                    Estudio de la variabilidad climática de temperaturas en el
                    valle del Mantaro
                  </li>
                  <li>
                    Estudio de la variabilidad climática de lluvias en el valle
                    del río Mantaro
                  </li>
                  <li>de la sensibilidad del modelo climático RegCM</li>
                </List>
              </li>
              <li>
                <b>
                  Desarrollar pronósticos de lluvias y temperaturas en el valle
                  del río Mantaro
                </b>
                <List tag="ol">
                  <li>
                    Desarrollo del modelo estadístico de predicción de lluvias y
                    temperaturas en el valle del río Mantaro
                  </li>
                  <li>Validación del modelo de pronóstico</li>
                  <li>
                    Pronostico de lluvias y temperatura usando el modelo
                    estadístico
                  </li>
                </List>
              </li>
              <li>
                <b>
                  Desarrollar las herramientas que permitan utilizar los
                  pronósticos climáticos por los potenciales usuarios en el
                  valle del río Mantaro
                </b>
                <List tag="ol">
                  <li>
                    Homogenización de conceptos entre el personal base y los
                    potenciales usuarios
                  </li>
                  <li>
                    Incorporación de necesidades de los potenciales usuarios en
                    el desarrollo de los pronósticos
                  </li>
                  <li>
                    Desarrollo de herramientas de diseminación de pronósticos
                    climáticos
                  </li>
                  <li>
                    del uso de las herramientas de diseminación de pronósticos
                    climáticos
                  </li>
                </List>
              </li>
              <li>
                <b>
                  Fortalecer el desarrollo institucional en las áreas de
                  desarrollo de pronósticos estacionales con aplicación en la
                  agricultura
                </b>
                <List tag="ol">
                  <li>Capacitación del personal encargado del subproyecto</li>
                  <li>Realización de tesis</li>
                  <li>Inversiones en infraestructura y equipos</li>
                  <li>Desarrollo de actividades de seguimiento y evaluación</li>
                  <li>
                    Desarrollo de actividades de diseminación y distribución de
                    resultados
                  </li>
                </List>
              </li>
            </List>
          </Navtab>
          <Navtab id="entidades">
            <Title tag="h2">
              Entidades colaboradoras
            </Title>
            <List class="list--grid">
              <li
                class="is-relative"
                style="display: flex; justify-content: center; align-items: center;"
              >
                <Figure>
                  <Image
                    fullSize
                    :srcsets="[
                      '/images/proyectos/incagro/Agronomia-150x150.png'
                    ]"
                    title="Facultad de Agronomía - Universidad Nacional del Centro del Perú (UNCP)"
                  />
                </Figure>
                <a href="https://uncp.edu.pe/" target="_blank" class="mock">
                  Facultad de Agronomía - Universidad Nacional del Centro del
                  Perú (UNCP)
                </a>
              </li>
              <li
                class="is-relative"
                style="display: flex; justify-content: center; align-items: center;"
              >
                <Figure>
                  <Image
                    fullSize
                    :srcsets="['/images/proyectos/incagro/inia.jpg']"
                    title="Instituto Nacional de Investigaciones y Extensión Agraria (INIEA)"
                  />
                </Figure>
                <a href="https://www.gob.pe/inia" target="_blank" class="mock">
                  Instituto Nacional de Investigaciones y Extensión Agraria
                  (INIEA)
                </a>
              </li>
            </List>
          </Navtab>
          <Navtab id="resultados">
            <Title tag="h2">
              Resultados
            </Title>
            <List tag="ol">
              <li>
                Se cuenta con una base de datos para el sub proyecto.
                <!--
                  <a href="http://clima.igp.gob.pe:8080/incagro4/incagro4.wwv_main.gohome">base de datos</a> para el sub proyecto.
                -->
              </li>
              <li>
                Se realizó estudios de la variabilidad de las lluvias y
                temperaturas extremas del aire, utilizando del valle del
                Mantaro, así como sus tendencias en los últimos 40-50 años. Se
                han realizado simulaciones con el modelo RegCM3 para los años
                determinados como secos y lluviosos con una resolución de 50km,
                a escala de la cuenca se ejecutará el modelo con 20km.
              </li>
              <li>
                Se desarrolló modelos de
                <a
                  href="http://met.igp.gob.pe/proyectos/incagro/pronostico/"
                  target="_blank"
                >
                  pronósticos para la estación de Huayao, Jauja y Viques </a
                >. Actualmente se encuentra en su fase de validación.
              </li>
              <li>
                Se continúan homogenizando los conceptos técnicos y
                socioeconómicos utilizado por los participantes, e incorporando
                las necesidades de los potenciales usuarios de la información
                climática, mediante talleres y la
                <a
                  href="http://met.igp.gob.pe/proyectos/incagro/pronostico/"
                  target="_blank"
                >
                  pagina web con resultado de los pronósticos </a
                >.
              </li>
              <li>
                <p>Se realizaron los siguientes trabajos de investigación:</p>
                <List marked>
                  <li>
                    <a
                      href="https://repositorio.igp.gob.pe/handle/20.500.12816/708"
                      target="_blank"
                    >
                      Libro Memoria del subproyecto "Pronóstico estacional de
                      lluvias y temperaturas en la cuenca del río Mantaro para
                      su aplicación en la agricultura 2007-2010"
                    </a>
                  </li>
                  <li>
                    <a
                      :href="`https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/resources/proyectos/incagro/manual.pdf`"
                      target="_blank"
                    >
                      Manual "Primera aproximación para la identificación de
                      tipos de suelos agrícola del valle del río Mantaro
                    </a>
                    Mapas (<a
                      :href="`https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/resources/proyectos/incagro/mapasmanual.pdf`"
                      target="_blank"
                      >PDF</a
                    >). Datos (<a
                      href="/resources/DATOS%20ANÁLISIS%20DE%20SUELO%20VALE%20DEL%20%20MANTARO.xls"
                      target="_blank"
                      >PDF</a
                    >)
                  </li>
                  <li>
                    Manual de uso consuntivo del agua para los principales
                    cultivos de los Andes Centrales Peruanos (<a
                      href="http://met.igp.gob.pe/proyectos/incagro/datos/ManualConsuntivo.pdf"
                      target="_blank"
                      >PDF</a
                    >)
                  </li>
                  <li>
                    <a
                      href="https://repositorio.igp.gob.pe/handle/20.500.12816/9"
                      target="_blank"
                    >
                      Comparación de los métodos regresión multivaridada
                      adaptativa utilizando splines (MARS) y redes neuronales
                      artificiales backpropagation (RNAB) para el pronóstico de
                      lluvias y temperatura en la cuenca del río Mantaro
                    </a>
                  </li>
                  <li>
                    Influencia de la temperatura, precipitación y fotoperíodo en
                    el cultivo de papa (Solanum tuberosum) variedades Canchan y
                    Yungay en los distritos de El Tambo y El Mantaro
                    <a href=""></a>
                  </li>
                  <li>
                    Influencia de la temperatura y precipitación en el cultivo
                    maíz amiláceo (zea mays L.) cv. San Gerónimo y Blanco
                    Urubamba en el valle del Mantaro
                    <a href=""></a>
                  </li>
                  <li>
                    Fluctuación poblacional de los cogolleros en maíz bajo
                    condiciones de temperatura, precipitación, humedad y
                    radiación solar en el valle del Mantaro
                    <a href=""></a>
                  </li>
                  <li>
                    Influencia de la precipitación y temperatura del aire en el
                    cultivo de la Quinua.
                    <a href=""></a>

                    <!--   T E S I S    N O   S U S T E N T A D A S

      <li>"Fluctuaci&oacute;n poblacional de los Eurysacca melacocampta Meyrick en condiciones de temperatura, precipitaci&oacute;n y enemigos biol&oacute;gicos en dos variedades de quinua en el valle del Mantaro", a cargo de un egresado de la especialidad de Agronom&iacute;a de la UNCP (Huancayo).
      <li>"Efecto de cuatro elementos clim&aacute;ticos en la din&aacute;mica poblacional de polillas en dos variedades de papa en las localidades de Tambo y Mantaro", a cargo de un egresado de la especialidad de Agronom&iacute;a de la UNCP (Huancayo).

      -->
                  </li>
                </List>
              </li>
            </List>
          </Navtab>
        </ColumnUi>
        <ColumnUi md="3">
          <Nav :items="navItems" title="Contenido" />
        </ColumnUi>
      </Row>
    </Container>
  </main>
</template>
<script>
import Trail from "@/components/common/Trail";
import Title from "@/components/ui/atoms/Title";
import List from "@/components/ui/objects/List";
import Container from "@/components/ui/objects/Container";
import Figure from "@/components/ui/objects/Figure";
import Image from "@/components/ui/objects/Image";
import Nav from "@/components/ui/objects/Nav";
import Navtab from "@/components/ui/objects/Navtab";
import Row from "@/components/ui/atoms/Row";
import ColumnUi from "@/components/ui/atoms/ColumnUi";
export default {
  components: {
    Trail,
    Title,
    List,
    Container,
    Figure,
    Image,
    Nav,
    Navtab,
    Row,
    ColumnUi
  },
  setup() {
    const navItems = [
      {
        path: "#introduccion",
        tag: "Introducción"
      },
      {
        path: "#objetivos",
        tag: "Objetivos general y específico del proyecto"
      },
      {
        path: "#duracion",
        tag: "Duración del proyecto"
      },
      {
        path: "#estrategias",
        tag: "Estrategias del proyecto"
      },
      {
        path: "#entidades",
        tag: "Entidades colaboradoras"
      },
      {
        path: "#resultados",
        tag: "Resultados"
      }
    ];
    return {
      navItems
    };
  }
};
</script>
